export const DASHBOARD_TABLE = [
  {
    id: 1,
    header: 'Cover page',
    type: 'Cover page',
    status: 'In Process',
    target: '18',
    limit: '5',
    reviewer: 'Eddie Lake',
  },
  {
    id: 2,
    header: 'Table of contents',
    type: 'Table of contents',
    status: 'Done',
    target: '29',
    limit: '24',
    reviewer: 'Eddie Lake',
  },
  {
    id: 3,
    header: 'Executive summary',
    type: 'Narrative',
    status: 'Done',
    target: '10',
    limit: '13',
    reviewer: 'Eddie Lake',
  },
  {
    id: 4,
    header: 'Technical approach',
    type: 'Narrative',
    status: 'Done',
    target: '27',
    limit: '23',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 5,
    header: 'Design',
    type: 'Narrative',
    status: 'In Process',
    target: '2',
    limit: '16',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 6,
    header: 'Capabilities',
    type: 'Narrative',
    status: 'In Process',
    target: '20',
    limit: '8',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 7,
    header: 'Integration with existing systems',
    type: 'Narrative',
    status: 'In Process',
    target: '19',
    limit: '21',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 8,
    header: 'Innovation and Advantages',
    type: 'Narrative',
    status: 'Done',
    target: '25',
    limit: '26',
    reviewer: 'Assign reviewer',
  },
  {
    id: 9,
    header: "Overview of EMR's Innovative Solutions",
    type: 'Technical content',
    status: 'Done',
    target: '7',
    limit: '23',
    reviewer: 'Assign reviewer',
  },
  {
    id: 10,
    header: 'Advanced Algorithms and Machine Learning',
    type: 'Narrative',
    status: 'Done',
    target: '30',
    limit: '28',
    reviewer: 'Assign reviewer',
  },
  {
    id: 11,
    header: 'Adaptive Communication Protocols',
    type: 'Narrative',
    status: 'Done',
    target: '9',
    limit: '31',
    reviewer: 'Assign reviewer',
  },
  {
    id: 12,
    header: 'Advantages Over Current Technologies',
    type: 'Narrative',
    status: 'Done',
    target: '12',
    limit: '0',
    reviewer: 'Assign reviewer',
  },
  {
    id: 13,
    header: 'Past Performance',
    type: 'Narrative',
    status: 'Done',
    target: '22',
    limit: '33',
    reviewer: 'Assign reviewer',
  },
  {
    id: 14,
    header: 'Customer Feedback and Satisfaction Levels',
    type: 'Narrative',
    status: 'Done',
    target: '15',
    limit: '34',
    reviewer: 'Assign reviewer',
  },
  {
    id: 15,
    header: 'Implementation Challenges and Solutions',
    type: 'Narrative',
    status: 'Done',
    target: '3',
    limit: '35',
    reviewer: 'Assign reviewer',
  },
  {
    id: 16,
    header: 'Security Measures and Data Protection Policies',
    type: 'Narrative',
    status: 'In Process',
    target: '6',
    limit: '36',
    reviewer: 'Assign reviewer',
  },
  {
    id: 17,
    header: 'Scalability and Future Proofing',
    type: 'Narrative',
    status: 'Done',
    target: '4',
    limit: '37',
    reviewer: 'Assign reviewer',
  },
  {
    id: 18,
    header: 'Cost-Benefit Analysis',
    type: 'Plain language',
    status: 'Done',
    target: '14',
    limit: '38',
    reviewer: 'Assign reviewer',
  },
  {
    id: 19,
    header: 'User Training and Onboarding Experience',
    type: 'Narrative',
    status: 'Done',
    target: '17',
    limit: '39',
    reviewer: 'Assign reviewer',
  },
  {
    id: 20,
    header: 'Future Development Roadmap',
    type: 'Narrative',
    status: 'Done',
    target: '11',
    limit: '40',
    reviewer: 'Assign reviewer',
  },
  {
    id: 21,
    header: 'System Architecture Overview',
    type: 'Technical content',
    status: 'In Process',
    target: '24',
    limit: '18',
    reviewer: 'Maya Johnson',
  },
  {
    id: 22,
    header: 'Risk Management Plan',
    type: 'Narrative',
    status: 'Done',
    target: '15',
    limit: '22',
    reviewer: 'Carlos Rodriguez',
  },
  {
    id: 23,
    header: 'Compliance Documentation',
    type: 'Legal',
    status: 'In Process',
    target: '31',
    limit: '27',
    reviewer: 'Sarah Chen',
  },
  {
    id: 24,
    header: 'API Documentation',
    type: 'Technical content',
    status: 'Done',
    target: '8',
    limit: '12',
    reviewer: 'Raj Patel',
  },
  {
    id: 25,
    header: 'User Interface Mockups',
    type: 'Visual',
    status: 'In Process',
    target: '19',
    limit: '25',
    reviewer: 'Leila Ahmadi',
  },
  {
    id: 26,
    header: 'Database Schema',
    type: 'Technical content',
    status: 'Done',
    target: '22',
    limit: '20',
    reviewer: 'Thomas Wilson',
  },
  {
    id: 27,
    header: 'Testing Methodology',
    type: 'Technical content',
    status: 'In Process',
    target: '17',
    limit: '14',
    reviewer: 'Assign reviewer',
  },
  {
    id: 28,
    header: 'Deployment Strategy',
    type: 'Narrative',
    status: 'Done',
    target: '26',
    limit: '30',
    reviewer: 'Eddie Lake',
  },
  {
    id: 29,
    header: 'Budget Breakdown',
    type: 'Financial',
    status: 'In Process',
    target: '13',
    limit: '16',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 30,
    header: 'Market Analysis',
    type: 'Research',
    status: 'Done',
    target: '29',
    limit: '32',
    reviewer: 'Sophia Martinez',
  },
  {
    id: 31,
    header: 'Competitor Comparison',
    type: 'Research',
    status: 'In Process',
    target: '21',
    limit: '19',
    reviewer: 'Assign reviewer',
  },
  {
    id: 32,
    header: 'Maintenance Plan',
    type: 'Technical content',
    status: 'Done',
    target: '16',
    limit: '23',
    reviewer: 'Alex Thompson',
  },
  {
    id: 33,
    header: 'User Personas',
    type: 'Research',
    status: 'In Process',
    target: '27',
    limit: '24',
    reviewer: 'Nina Patel',
  },
  {
    id: 34,
    header: 'Accessibility Compliance',
    type: 'Legal',
    status: 'Done',
    target: '18',
    limit: '21',
    reviewer: 'Assign reviewer',
  },
  {
    id: 35,
    header: 'Performance Metrics',
    type: 'Technical content',
    status: 'In Process',
    target: '23',
    limit: '26',
    reviewer: 'David Kim',
  },
  {
    id: 36,
    header: 'Disaster Recovery Plan',
    type: 'Technical content',
    status: 'Done',
    target: '14',
    limit: '17',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 37,
    header: 'Third-party Integrations',
    type: 'Technical content',
    status: 'In Process',
    target: '25',
    limit: '28',
    reviewer: 'Eddie Lake',
  },
  {
    id: 38,
    header: 'User Feedback Summary',
    type: 'Research',
    status: 'Done',
    target: '20',
    limit: '15',
    reviewer: 'Assign reviewer',
  },
  {
    id: 39,
    header: 'Localization Strategy',
    type: 'Narrative',
    status: 'In Process',
    target: '12',
    limit: '19',
    reviewer: 'Maria Garcia',
  },
  {
    id: 40,
    header: 'Mobile Compatibility',
    type: 'Technical content',
    status: 'Done',
    target: '28',
    limit: '31',
    reviewer: 'James Wilson',
  },
  {
    id: 41,
    header: 'Data Migration Plan',
    type: 'Technical content',
    status: 'In Process',
    target: '19',
    limit: '22',
    reviewer: 'Assign reviewer',
  },
  {
    id: 42,
    header: 'Quality Assurance Protocols',
    type: 'Technical content',
    status: 'Done',
    target: '30',
    limit: '33',
    reviewer: 'Priya Singh',
  },
  {
    id: 43,
    header: 'Stakeholder Analysis',
    type: 'Research',
    status: 'In Process',
    target: '11',
    limit: '14',
    reviewer: 'Eddie Lake',
  },
  {
    id: 44,
    header: 'Environmental Impact Assessment',
    type: 'Research',
    status: 'Done',
    target: '24',
    limit: '27',
    reviewer: 'Assign reviewer',
  },
  {
    id: 45,
    header: 'Intellectual Property Rights',
    type: 'Legal',
    status: 'In Process',
    target: '17',
    limit: '20',
    reviewer: 'Sarah Johnson',
  },
  {
    id: 46,
    header: 'Customer Support Framework',
    type: 'Narrative',
    status: 'Done',
    target: '22',
    limit: '25',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 47,
    header: 'Version Control Strategy',
    type: 'Technical content',
    status: 'In Process',
    target: '15',
    limit: '18',
    reviewer: 'Assign reviewer',
  },
  {
    id: 48,
    header: 'Continuous Integration Pipeline',
    type: 'Technical content',
    status: 'Done',
    target: '26',
    limit: '29',
    reviewer: 'Michael Chen',
  },
  {
    id: 49,
    header: 'Regulatory Compliance',
    type: 'Legal',
    status: 'In Process',
    target: '13',
    limit: '16',
    reviewer: 'Assign reviewer',
  },
  {
    id: 50,
    header: 'User Authentication System',
    type: 'Technical content',
    status: 'Done',
    target: '28',
    limit: '31',
    reviewer: 'Eddie Lake',
  },
  {
    id: 51,
    header: 'Data Analytics Framework',
    type: 'Technical content',
    status: 'In Process',
    target: '21',
    limit: '24',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 52,
    header: 'Cloud Infrastructure',
    type: 'Technical content',
    status: 'Done',
    target: '16',
    limit: '19',
    reviewer: 'Assign reviewer',
  },
  {
    id: 53,
    header: 'Network Security Measures',
    type: 'Technical content',
    status: 'In Process',
    target: '29',
    limit: '32',
    reviewer: 'Lisa Wong',
  },
  {
    id: 54,
    header: 'Project Timeline',
    type: 'Planning',
    status: 'Done',
    target: '14',
    limit: '17',
    reviewer: 'Eddie Lake',
  },
  {
    id: 55,
    header: 'Resource Allocation',
    type: 'Planning',
    status: 'In Process',
    target: '27',
    limit: '30',
    reviewer: 'Assign reviewer',
  },
  {
    id: 56,
    header: 'Team Structure and Roles',
    type: 'Planning',
    status: 'Done',
    target: '20',
    limit: '23',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 57,
    header: 'Communication Protocols',
    type: 'Planning',
    status: 'In Process',
    target: '15',
    limit: '18',
    reviewer: 'Assign reviewer',
  },
  {
    id: 58,
    header: 'Success Metrics',
    type: 'Planning',
    status: 'Done',
    target: '30',
    limit: '33',
    reviewer: 'Eddie Lake',
  },
  {
    id: 59,
    header: 'Internationalization Support',
    type: 'Technical content',
    status: 'In Process',
    target: '23',
    limit: '26',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 60,
    header: 'Backup and Recovery Procedures',
    type: 'Technical content',
    status: 'Done',
    target: '18',
    limit: '21',
    reviewer: 'Assign reviewer',
  },
  {
    id: 61,
    header: 'Monitoring and Alerting System',
    type: 'Technical content',
    status: 'In Process',
    target: '25',
    limit: '28',
    reviewer: 'Daniel Park',
  },
  {
    id: 62,
    header: 'Code Review Guidelines',
    type: 'Technical content',
    status: 'Done',
    target: '12',
    limit: '15',
    reviewer: 'Eddie Lake',
  },
  {
    id: 63,
    header: 'Documentation Standards',
    type: 'Technical content',
    status: 'In Process',
    target: '27',
    limit: '30',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 64,
    header: 'Release Management Process',
    type: 'Planning',
    status: 'Done',
    target: '22',
    limit: '25',
    reviewer: 'Assign reviewer',
  },
  {
    id: 65,
    header: 'Feature Prioritization Matrix',
    type: 'Planning',
    status: 'In Process',
    target: '19',
    limit: '22',
    reviewer: 'Emma Davis',
  },
  {
    id: 66,
    header: 'Technical Debt Assessment',
    type: 'Technical content',
    status: 'Done',
    target: '24',
    limit: '27',
    reviewer: 'Eddie Lake',
  },
  {
    id: 67,
    header: 'Capacity Planning',
    type: 'Planning',
    status: 'In Process',
    target: '21',
    limit: '24',
    reviewer: 'Jamik Tashpulatov',
  },
  {
    id: 68,
    header: 'Service Level Agreements',
    type: 'Legal',
    status: 'Done',
    target: '26',
    limit: '29',
    reviewer: 'Assign reviewer',
  },
];

export const BOOLEAN_ENUM = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

// class GenericStatus(str, Enum):
//     ACTIVE = "active"
//     INACTIVE = "inactive"
//     DELETED = "deleted"
//     ACCEPTED = "accepted"
//     REJECTED = "rejected"
//     PENDING = "pending"

export const GENERIC_STATUS_ENUM = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'In active' },
  {
    value: 'deleted',
    label: 'Deleted',
  },
  {
    value: 'accepted',
    label: 'Accepted',
  },
  {
    value: 'rejected',
    label: 'Rejected',
  },
  {
    value: 'pending',
    label: 'Pending',
  },
];

export const ASSIGNMENT_STATUS = [
  { value: 'draft', label: 'Draft' },
  { value: 'published', label: 'Published' },
];

export const STATUS_ENUM = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'In active' },
  // {
  //   value: 'deleted',
  //   label: 'Deleted',
  // },
  // {
  //   value: 'accepted',
  //   label: 'Accepted',
  // },
  // {
  //   value: 'rejected',
  //   label: 'Rejected',
  // },
  // {
  //   value: 'pending',
  //   label: 'Pending',
  // },
];

export const ROLEPLAY_LEVEL_ENUM = [
  { value: 'beginner', label: 'Beginner' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Advanced' },
];

export const ROLEPLAY_INTRO_TYPE_ENUM = [
  { value: 'text', label: 'Text' },
  { value: 'pdf', label: 'PDF' },
  { value: 'video', label: 'Video' },
  { value: 'none', label: 'None' },
];

export const RESOURCE_TYPE_ENUMS = [
  // {
  //   label: 'All resources',
  //   value: '*',
  // },
  {
    label: 'Dashboard',
    value: 'dashboard',
  },
  {
    label: 'User',
    value: 'user',
  },
  {
    label: 'Organization',
    value: 'organization',
  },
  {
    label: 'Role',
    value: 'role',
  },
  {
    label: 'Permission',
    value: 'permission',
  },
  {
    label: 'Invitation',
    value: 'invitation',
  },
  {
    label: 'Prompt',
    value: 'prompt',
  },
  {
    label: 'Avatar',
    value: 'avatar',
  },
  {
    label: 'Voice',
    value: 'voice',
  },
  {
    label: 'Role play',
    value: 'role_play',
  },
  {
    label: 'Role play course',
    value: 'role_play_course',
  },
  {
    label: 'User setting',
    value: 'user_setting',
  },
  {
    label: 'User profile',
    value: 'user_profile',
  },
  {
    label: 'User group',
    value: 'user_group',
  },
  {
    label: 'Subscription',
    value: 'subscription',
  },
  {
    label: 'User Homepage',
    value: 'user_home',
  },
  {
    label: 'Reports',
    value: 'reports',
  },
];

export const ACTION_TYPE_ENUMS = [
  {
    value: '*',
    label: 'All actions',
  },
  {
    value: 'read',
    label: 'Read',
  },
  {
    value: 'create',
    label: 'Create',
  },
  {
    value: 'update',
    label: 'Update',
  },
  {
    value: 'delete',
    label: 'Delete',
  },
];

export const COURSE_CATEGORIES = [
  'Technology & Programming',
  'Business & Management',
  'Health & Safety',
  'Communication Skills',
  'Professional Development',
  'Other',
];

export const COURSE_CATEGORY_DESCRIPTIONS = {
  'Technology & Programming':
    'Hands-on technical roleplays focused on coding, tooling, architecture, and dev workflows.',

  'Business & Management':
    'Scenarios for decision-making, leadership, planning, and operational excellence.',

  'Health & Safety':
    'Compliance, emergency response, and safe-practice simulations for regulated environments.',

  'Communication Skills':
    'Practice for presentations, stakeholder alignment, negotiation, and feedback delivery.',

  'Professional Development':
    'Career growth, performance, mentoring, and workplace effectiveness scenarios.',

  Other: 'Everything that doesn’t fit neatly into the above categories or is experimental.',
};

/**
 * Marketplace templates data for Roleplay
 */
export const MARKETPLACE_TEMPLATES = [
  {
    id: 1,
    title: 'Customer Support Roleplay',
    desc: 'Helps simulate common customer queries and support responses. This template includes scenarios like billing issues, product troubleshooting, and refund requests, allowing users to practice empathy, active listening, and effective problem solving in a safe environment.',
    category: 'Suggested',
  },
  {
    id: 2,
    title: 'Sales Pitch Scenario',
    desc: 'Designed to practice persuasive sales conversations. It guides users through structured opening lines, objection handling, and closing techniques. The template emphasizes confidence, rapport building, and tailoring pitches to customer needs, making it ideal for sales teams and entrepreneurs.',
    category: 'Suggested',
  },
  {
    id: 3,
    title: 'Conflict Resolution',
    desc: 'Teaches handling of difficult customer situations calmly. Users will engage in realistic roleplay exercises where they must de-escalate tense interactions, manage emotional responses, and work toward win–win solutions. Great for training customer service reps and team leaders.',
    category: 'Standard',
  },
  {
    id: 4,
    title: 'Product Training Roleplay',
    desc: 'Explains product features & FAQs in a mock training format. This template helps teams learn how to introduce new features, answer technical questions, and demonstrate product value. It is especially useful for onboarding new hires and preparing for client-facing demos.',
    category: 'Standard',
  },
  {
    id: 5,
    title: 'Interview Practice',
    desc: 'Roleplay common interview questions & answers to build confidence before the real thing. Includes behavioral questions, technical tests, and cultural-fit assessments. This template helps candidates improve their communication, storytelling, and problem-solving under pressure.',
    category: 'Standard',
  },
  {
    id: 6,
    title: 'Team Collaboration',
    desc: 'Focuses on internal communication and teamwork exercises. The scenarios cover project kickoffs, brainstorming sessions, and conflict management within a team. This template encourages clear communication, collaboration, and leadership skills, making it valuable for managers and employees alike.',
    category: 'Standard',
  },
];

/**
 * Marketplace templates data for Course
 */
export const COURSE_MARKETPLACE_TEMPLATES = [
  {
    id: 1,
    title: 'Introduction to Digital Marketing',
    desc: 'Learn the essentials of digital marketing including SEO, social media strategy, paid advertising, and content marketing. This template helps users understand how to build an online presence and measure success across different channels.',
    category: 'Suggested',
  },
  {
    id: 2,
    title: 'Full-Stack Web Development',
    desc: 'Covers front-end (HTML, CSS, JavaScript, React) and back-end (Node.js, Express, databases) with hands-on projects. Learners build a portfolio site and an e-commerce application to practice real-world skills.',
    category: 'Suggested',
  },
  {
    id: 3,
    title: 'Data Science & Machine Learning',
    desc: 'Introduces Python for data analysis and machine learning. Learners work with pandas, NumPy, and scikit-learn while applying concepts to real-world case studies like churn prediction and recommendation engines.',
    category: 'Standard',
  },
  {
    id: 4,
    title: 'Public Speaking & Communication Skills',
    desc: 'Helps learners overcome stage fear and improve communication. Focus areas include structuring presentations, storytelling, body language, and audience engagement exercises.',
    category: 'Standard',
  },
  {
    id: 5,
    title: 'Cybersecurity Fundamentals',
    desc: 'Explains key concepts of cybersecurity such as network protection, encryption, ethical hacking, and threat detection. Learners understand how to secure personal and organizational data.',
    category: 'Standard',
  },
  {
    id: 6,
    title: 'Entrepreneurship & Startup Essentials',
    desc: 'Guides learners through idea validation, business model design, fundraising, and go-to-market planning. Includes practical startup case studies to help aspiring founders.',
    category: 'Standard',
  },
  {
    id: 7,
    title: 'Artificial Intelligence for Business',
    desc: 'Explains how AI can transform marketing, HR, and operations through predictive analytics, automation, and natural language processing. Suitable for professionals looking to apply AI in business.',
    category: 'Standard',
  },
  {
    id: 8,
    title: 'Creative Writing Masterclass',
    desc: 'Teaches storytelling, character building, and narrative structure. Learners engage in exercises for short stories, essays, and creative brainstorming to strengthen writing skills.',
    category: 'Standard',
  },
];

/**
 * Anam ai avatars
 */
export const ANAM_AI_AVATARS = [
  {
    id: 'gabriel_table',
    name: 'Gabriel - table',
    url: 'https://lab.anam.ai/persona_thumbnails/gabriel_table.png',
  },
  {
    id: 'mia_studio',
    name: 'Mia - studio',
    url: 'https://lab.anam.ai/persona_thumbnails/mia_studio.png',
  },
  {
    id: 'richard_table',
    name: 'Richard - table',
    url: 'https://lab.anam.ai/persona_thumbnails/richard_table.png',
  },
  {
    id: 'liv_home',
    name: 'Liv - home',
    url: 'https://lab.anam.ai/persona_thumbnails/liv_home.png',
  },
  {
    id: 'william_lean',
    name: 'William - lean',
    url: 'https://lab.anam.ai/persona_thumbnails/william_lean.png',
  },
  {
    id: 'julia_sofa',
    name: 'Julia - sofa',
    url: 'https://lab.anam.ai/persona_thumbnails/julia_sofa.png',
  },
  {
    id: 'finn_lean',
    name: 'Finn - lean',
    url: 'https://lab.anam.ai/persona_thumbnails/finn_lean.png',
  },
  {
    id: 'anne_home',
    name: 'Anne - home',
    url: 'https://lab.anam.ai/persona_thumbnails/anne_home.png',
  },
  {
    id: 'hunter_table',
    name: 'Hunter - table',
    url: 'https://lab.anam.ai/persona_thumbnails/hunter_table.png',
  },
  {
    id: 'bella_sofa',
    name: 'Bella - sofa',
    url: 'https://lab.anam.ai/persona_thumbnails/bella_sofa.png',
  },
  {
    id: 'kevin_table',
    name: 'Kevin - table',
    url: 'https://lab.anam.ai/persona_thumbnails/kevin_table.png',
  },
  {
    id: 'layla_home',
    name: 'Layla - home',
    url: 'https://lab.anam.ai/persona_thumbnails/layla_home.png',
  },
  {
    id: 'sophie_sofa',
    name: 'Sophie - sofa',
    url: 'https://lab.anam.ai/persona_thumbnails/sophie_sofa.png',
  },
  {
    id: 'alister_desk',
    name: 'Alister - desk',
    url: 'https://lab.anam.ai/persona_thumbnails/alister_desk.png',
  },
  {
    id: 'alister_windowsofa',
    name: 'Alister - window sofa',
    url: 'https://lab.anam.ai/persona_thumbnails/alister_windowsofa.png',
  },
  {
    id: 'alister_windowdesk',
    name: 'Alister - window desk',
    url: 'https://lab.anam.ai/persona_thumbnails/alister_windowdesk.png',
  },
  {
    id: 'astrid_desk',
    name: 'Astrid - desk',
    url: 'https://lab.anam.ai/persona_thumbnails/astrid_desk.png',
  },
  {
    id: 'astrid_windowdesk',
    name: 'Astrid - window desk',
    url: 'https://lab.anam.ai/persona_thumbnails/astrid_windowdesk.png',
  },
  {
    id: 'astrid_windowsofacorner',
    name: 'Astrid - window sofa corner',
    url: 'https://lab.anam.ai/persona_thumbnails/astrid_windowsofacorner.png',
  },
  {
    id: 'cara_windowsofa',
    name: 'Cara - window sofa',
    url: 'https://lab.anam.ai/persona_thumbnails/cara_windowsofa.png',
  },
  {
    id: 'cara_desk',
    name: 'Cara - desk',
    url: 'https://lab.anam.ai/persona_thumbnails/cara_desk.png',
  },
  {
    id: 'cara_windowdesk',
    name: 'Cara - window desk',
    url: 'https://lab.anam.ai/persona_thumbnails/cara_windowdesk.png',
  },
  {
    id: 'evelyn_windowsofacorner',
    name: 'Evelyn - window sofa corner',
    url: 'https://lab.anam.ai/persona_thumbnails/evelyn_windowsofacorner.png',
  },
  {
    id: 'evelyn_desk',
    name: 'Evelyn - desk',
    url: 'https://lab.anam.ai/persona_thumbnails/evelyn_desk.png',
  },
  {
    id: 'evelyn_windowdesk',
    name: 'Evelyn - window desk',
    url: 'https://lab.anam.ai/persona_thumbnails/evelyn_windowdesk.png',
  },
  {
    id: 'leo_windowdesk',
    name: 'Leo - window desk',
    url: 'https://lab.anam.ai/persona_thumbnails/leo_windowdesk.png',
  },
  {
    id: 'leo_windowsofacorner',
    name: 'Leo - window sofa corner',
    url: 'https://lab.anam.ai/persona_thumbnails/leo_windowsofacorner.png',
  },
  {
    id: 'leo_desk',
    name: 'Leo - desk',
    url: 'https://lab.anam.ai/persona_thumbnails/leo_desk.png',
  },
  {
    id: 'pablo_windowdesk',
    name: 'Pablo - window desk',
    url: 'https://lab.anam.ai/persona_thumbnails/pablo_windowdesk.png',
  },
  {
    id: 'pablo_desk',
    name: 'Pablo - desk',
    url: 'https://lab.anam.ai/persona_thumbnails/pablo_desk.png',
  },
  {
    id: 'pablo_windowsofa',
    name: 'Pablo - window sofa',
    url: 'https://lab.anam.ai/persona_thumbnails/pablo_windowsofa.png',
  },
];

// Temp data
export const ROLE_PLAYES = [
  {
    id: 1,
    title: 'Customer Service Excellence',
    description:
      'Practice handling difficult customer situations with realistic scenarios and comprehensive feedback systems.',
    status: 'Published',
    participants: 25,
    category: 'Customer Service',
  },
  {
    id: 2,
    title: 'Sales Negotiation Mastery',
    description:
      'Develop advanced negotiation skills through interactive roleplay exercises and real-world scenarios.',
    status: 'Draft',
    participants: 12,
    category: 'Sales & Marketing',
  },
  {
    id: 3,
    title: 'Leadership Communication',
    description:
      'Build effective leadership communication skills through challenging interpersonal scenarios.',
    status: 'Published',
    participants: 34,
    category: 'Leadership',
  },
  {
    id: 4,
    title: 'Leadership Communication',
    description:
      'Build effective leadership communication skills through challenging interpersonal scenarios.',
    status: 'Published',
    participants: 34,
    category: 'Leadership',
  },
  {
    id: 5,
    title: 'Leadership Communication',
    description:
      'Build effective leadership communication skills through challenging interpersonal scenarios.',
    status: 'Published',
    participants: 34,
    category: 'Leadership',
  },
];

export const COURSES = [
  {
    id: 1,
    title: 'Leadership Fundamentals',
    description:
      'Comprehensive course covering essential leadership principles, team management, and strategic thinking.',
    status: 'Published',
    enrollments: 150,
    category: 'Leadership',
  },
  {
    id: 2,
    title: 'Digital Marketing Strategy',
    description:
      'Learn advanced digital marketing strategies, analytics, and campaign optimization techniques.',
    status: 'Published',
    enrollments: 89,
    category: 'Sales & Marketing',
  },
  {
    id: 3,
    title: 'Technical Skills Bootcamp',
    description:
      'Intensive technical training covering modern development practices and industry best practices.',
    status: 'Draft',
    enrollments: 67,
    category: 'Technical Skills',
  },
  {
    id: 4,
    title: 'Technical Skills Bootcamp',
    description:
      'Intensive technical training covering modern development practices and industry best practices.',
    status: 'Draft',
    enrollments: 67,
    category: 'Technical Skills',
  },
  {
    id: 5,
    title: 'Technical Skills Bootcamp',
    description:
      'Intensive technical training covering modern development practices and industry best practices.',
    status: 'Draft',
    enrollments: 67,
    category: 'Technical Skills',
  },
];

export const DEFAULT_SELECTED_CRITERIA = [
  { id: 'c1', title: 'Discovery & Needs Diagnosis' },
  { id: 'c2', title: 'Articulation of Value & Business Impact' },
  { id: 'c3', title: 'Solution Positioning & Relevance' },
  { id: 'c4', title: 'Use of Evidence, Data & Proof Points' },
  { id: 'c5', title: 'Objection Handling & Reframing' },
  { id: 'c6', title: 'Credibility & Trust Building' },
  { id: 'c7', title: 'Closing & Commitment Building' },
];

export const DEFAULT_POOL_OF_PRACTICES = [
  { id: 'p1', title: 'Time Management', description: 'Uses time efficiently during the session.' },
  {
    id: 'p2',
    title: 'Adaptability',
    description: 'Adapts to new information and changing context.',
  },
  {
    id: 'p3',
    title: 'Active Listening',
    description: 'Reflects and clarifies to ensure understanding.',
  },
  { id: 'p4', title: 'Empathy', description: 'Demonstrates empathy and respect.' },
  { id: 'p5', title: 'Data Literacy', description: 'Interprets and applies data insights.' },
  { id: 'p6', title: 'Creativity', description: 'Generates novel, useful ideas.' },
  { id: 'p7', title: 'Conflict Resolution', description: 'Navigates disagreements productively.' },
];

export const assessmentsList = [
  {
    title: 'Project Alpha',
    description: 'AI-based customer support assistant',
    promptText: 'This assessment aims to understand your engagement and...',
    organization: 'OpenAI Labs',
    status: 'Active',
  },
  {
    title: 'Customer Satisfaction Survey',
    description: 'Survey Quarterly survey to measure customer satisfaction',
    promptText: 'Please rate your satisfaction on a scale of 1-10...',
    organization: 'HR Department',
    status: 'In Review',
  },
  {
    title: 'Project Alpha',
    description: 'AI-based customer support assistant',
    promptText: 'This assessment aims to understand your engagement and...',
    organization: 'OpenAI Labs',
    status: 'Completed',
  },
  {
    title: 'Customer Satisfaction Survey',
    description: 'Survey Quarterly survey to measure customer satisfaction',
    promptText: 'Please rate your satisfaction on a scale of 1-10...',
    organization: 'HR Department',
    status: 'In Review',
  },
  {
    title: 'Project Alpha',
    description: 'AI-based customer support assistant',
    promptText: 'This assessment aims to understand your engagement and...',
    organization: 'OpenAI Labs',
    status: 'Active',
  },
  {
    title: 'Customer Satisfaction Survey',
    description: 'Survey Quarterly survey to measure customer satisfaction',
    promptText: 'Please rate your satisfaction on a scale of 1-10...',
    organization: 'HR Department',
    status: 'In Review',
  },
  {
    title: 'Project Alpha',
    description: 'AI-based customer support assistant',
    promptText: 'This assessment aims to understand your engagement and...',
    organization: 'OpenAI Labs',
    status: 'Active',
  },
  {
    title: 'Customer Satisfaction Survey',
    description: 'Survey Quarterly survey to measure customer satisfaction',
    promptText: 'Please rate your satisfaction on a scale of 1-10...',
    organization: 'HR Department',
    status: 'In Review',
  },
  {
    title: 'Project Alpha',
    description: 'AI-based customer support assistant',
    promptText: 'This assessment aims to understand your engagement and...',
    organization: 'OpenAI Labs',
    status: 'Active',
  },
  {
    title: 'Customer Satisfaction Survey',
    description: 'Survey Quarterly survey to measure customer satisfaction',
    promptText: 'Please rate your satisfaction on a scale of 1-10...',
    organization: 'HR Department',
    status: 'In Review',
  },
  {
    title: 'Project Alpha',
    description: 'AI-based customer support assistant',
    promptText: 'This assessment aims to understand your engagement and...',
    organization: 'OpenAI Labs',
    status: 'Active',
  },
  {
    title: 'Customer Satisfaction Survey',
    description: 'Survey Quarterly survey to measure customer satisfaction',
    promptText: 'Please rate your satisfaction on a scale of 1-10...',
    organization: 'HR Department',
    status: 'In Review',
  },
  {
    title: 'Project Alpha',
    description: 'AI-based customer support assistant',
    promptText: 'This assessment aims to understand your engagement and...',
    organization: 'OpenAI Labs',
    status: 'Active',
  },
  {
    title: 'Customer Satisfaction Survey',
    description: 'Survey Quarterly survey to measure customer satisfaction',
    promptText: 'Please rate your satisfaction on a scale of 1-10...',
    organization: 'HR Department',
    status: 'In Review',
  },
  {
    title: 'Project Alpha',
    description: 'AI-based customer support assistant',
    promptText: 'This assessment aims to understand your engagement and...',
    organization: 'OpenAI Labs',
    status: 'Active',
  },
  {
    title: 'Customer Satisfaction Survey',
    description: 'Survey Quarterly survey to measure customer satisfaction',
    promptText: 'Please rate your satisfaction on a scale of 1-10...',
    organization: 'HR Department',
    status: 'In Review',
  },
];

export const mockDashboardData = {
  status_code: 200,
  data: {
    data: {
      anam_usage_data: [
        {
          id: 'a1',
          organization_name: 'imled',
          user_name: 'Victor Johnson',
          user_email: 'victor@imled.ai',
          total_usage: 43216,
          createdAt: '2025-11-06T12:33:59.001Z', // within last 7 days
        },
        {
          id: 'a2',
          organization_name: 'imled',
          user_name: 'Jane Doe',
          user_email: 'jane@imled.ai',
          total_usage: 42100,
          createdAt: '2025-10-10T09:00:00.000Z', // last 30 days
        },
        {
          id: 'a3',
          organization_name: 'imled',
          user_name: 'John Smith',
          user_email: 'john@imled.ai',
          total_usage: 38900,
          createdAt: '2025-08-22T05:00:00.000Z', // older than 90 days
        },
      ],

      chatgpt_usage: [
        {
          id: 'c1',
          organization_name: 'imled',
          user_name: 'Victor Johnson',
          total_usage: 120,
          createdAt: '2025-11-05T03:24:04.276Z',
        },
        {
          id: 'c2',
          organization_name: 'imled',
          user_name: 'Jane Doe',
          total_usage: 260,
          createdAt: '2025-09-15T03:24:04.276Z', // 50+ days ago
        },
        {
          id: 'c3',
          organization_name: 'imled',
          user_name: 'Ava Bright',
          total_usage: 580,
          createdAt: '2025-06-11T03:24:04.276Z', // very old
        },
      ],

      organizations: [
        {
          id: 'o1',
          name: 'Imled',
          slug: 'imled',
          status: 'active',
          website: 'https://imled.ai',
        },
        {
          id: 'o2',
          name: 'Ditinex Enterprise',
          slug: 'ditinex-enterprise',
          status: 'active',
          website: 'https://www.ditinex.com',
        },
      ],

      recent_active_users: [
        {
          id: 'u1',
          user_name: 'Victor Johnson',
          user_email: 'victor@imled.ai',
          createdAt: '2025-11-04T10:00:00.000Z', // within last 7 days
        },
        {
          id: 'u2',
          user_name: 'Jane Doe',
          user_email: 'jane@imled.ai',
          createdAt: '2025-10-03T10:00:00.000Z', // within 30 days
        },
        {
          id: 'u3',
          user_name: 'John Smith',
          user_email: 'john@imled.ai',
          createdAt: '2025-07-15T10:00:00.000Z', // older than 90 days
        },
      ],

      recent_anam_avatars: [
        {
          id: 'av1',
          name: 'Avatar One',
          createdAt: '2025-11-07T08:00:00.000Z',
        },
        {
          id: 'av2',
          name: 'Avatar Two',
          createdAt: '2025-09-22T08:00:00.000Z',
        },
      ],

      recent_roleplays: [
        {
          id: 'rp1',
          title: 'Marketing Chat',
          createdAt: '2025-11-06T11:00:00.000Z',
        },
        {
          id: 'rp2',
          title: 'Sales Pitch Roleplay',
          createdAt: '2025-08-10T11:00:00.000Z',
        },
      ],

      chatgpt_usage_count: 8314,
      total_anam_usage: 87591,
      total_organizations: 3,
      total_user: 32,
      message: 'Recent activity retrieved successfully',
      status: true,
    },
  },
};
